<mat-card class="width-gt-xs" data-cy="SommertrainingPage" role="article">
    <mat-card-header role="heading">
        <mat-card-title>Sommertraining</mat-card-title>
    </mat-card-header>
    <mat-card-content>
                    <p>
                        In der Saison von Ende März bis Ende Oktober treffen wir uns Dienstags ab 17:30 Uhr am
                        Bootshaus. Von dort wird gemeinsam oder in kleineren Gruppen gestartet. Gepaddelt wird auf dem
                        Main, je nach Lust und Laune in Wanderbooten, Seekajaks und Kanadiern. Auch Wildwasser- und
                        Poloboote stehen zur Verfügung. Sehr beliebt ist auch das Paddeln im Stehen auf den SUP-Boards.
                    </p>
                    <p>
                        So gut wie immer findet sich eine Gruppe zur gemütlichen Feierabendrunde zusammen. AnfängerInnen
                        zum Schnupperpaddeln sind hier herzlich willkommen.
                    </p>
                    <p>
                        Zum sportlicheren Paddeln finden sich jene ein, die mit höherem Tempo auf die längere Strecke
                        (ca. 15km) gehen. Hier kommen Seekajaks, Surfskis und Abfahrtsboote zum Einsatz. Klar, dass im
                        Anschluss an das Training das gemütliche Beisammensein auf der Terrasse des Bootshauses nicht zu
                        kurz kommt.
                    </p>
                    <p>
                        Eine Besonderheit ist unsere Kanupolo-Anlage auf dem Main. Wir haben zur Zeit keine aktive
                        Mannschaft aber in den letzten Jahren wird wieder vermehrt Kanupolo gespielt. Die Gruppe setzt
                        sich aus PaddlerInnen verschiedener Kanuvereine zusammen. Gespielt wird meist Mittwochs.
                    </p>

                    <div class="flex-container-images">
                        @for (bild of bilderliste; track i; let i = $index) {
                            <div class="flex-grow flexbase-images" style="text-align: center" [attr.data-cy]="'bild-' + i">
                                <img
                                    [src]="bild"
                                    alt="Bild vom Paddeln auf dem Main"
                                    style="vertical-align: middle; border-radius: 2%; width: 100%" />
                            </div>
                        }
                    </div>
    </mat-card-content>
</mat-card>
